const B = process.env.REACT_APP_BACKEND_URL;
const KEY = "vsk_sid";

function sid() {
  let s = sessionStorage.getItem(KEY);
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(KEY, s);
  }
  return s;
}

let lastPath = null;
export function pingVisit(path) {
  if (path === lastPath) return;
  lastPath = path;
  const body = JSON.stringify({ sid: sid(), path, ref: document.referrer || null });
  if (navigator.sendBeacon && navigator.sendBeacon(`${B}/api/visits/ping`, new Blob([body], { type: "application/json" }))) return;
  fetch(`${B}/api/visits/ping`, { method: "POST", headers: { "Content-Type": "application/json" }, body, credentials: "include", keepalive: true }).catch(() => {});
}

let bound = false;
export function bindVisitLifecycle() {
  if (bound) return;
  bound = true;
  const beat = () => { if (document.visibilityState === "visible" && lastPath) { lastPath = null; pingVisit(window.location.pathname); } };
  setInterval(beat, 60000);
  window.addEventListener("pagehide", () => {
    const body = JSON.stringify({ sid: sid(), path: window.location.pathname });
    if (navigator.sendBeacon) navigator.sendBeacon(`${B}/api/visits/ping`, new Blob([body], { type: "application/json" }));
  });
}
